import type { ReactNode } from 'react';

type LabeledGroupProps = {
  label?: string | null;
  children: ReactNode;
};

export function LabeledGroup({ label, children }: LabeledGroupProps) {
  return (
    <div className="flex flex-col gap-[36px]">
      {label ? (
        <p className="text-[16px] font-light leading-[1.5] text-[#041118] md:text-[18px]">
          {label}
        </p>
      ) : null}
      {children}
    </div>
  );
}
